export function orderEntitiesByIds<T extends { id: string }>(
  entities: T[],
  orderedIds: string[],
): T[] {
  const entityMap = new Map(entities.map((e) => [e.id, e]));
  const result: T[] = [];
  for (const id of orderedIds) {
    const entity = entityMap.get(id);
    if (entity) {
      result.push(entity);
      entityMap.delete(id);
    }
  }
  for (const entity of entityMap.values()) {
    result.push(entity);
  }
  return result;
}

export function updateOrderedIds(
  currentOrder: string[],
  activeId: string,
  overId: string,
): string[] {
  if (activeId === overId) return currentOrder;

  const next = currentOrder.filter((id) => id !== activeId);
  const overIndex = next.indexOf(overId);
  if (overIndex === -1) {
    next.push(activeId);
    return next;
  }
  next.splice(overIndex, 0, activeId);
  return next;
}
